(() => {
  if (window.ffCartVolumeCelebrationLoaded) return;
  window.ffCartVolumeCelebrationLoaded = true;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const getBar = () => document.querySelector('#CartDrawer .ff-cart-volume');
  const getTier = (count) => count >= 6 ? 6 : count >= 4 ? 4 : count >= 2 ? 2 : 0;
  const initialBar = getBar();
  let lastQuantity = initialBar ? Number(initialBar.dataset.quantity) : null;
  let lastFraction = Math.min(Math.max(lastQuantity || 0, 0), 6) / 6;
  let fillMotion = null;
  let detailMotions = [];
  let revision = 0;
  const getVisualFraction = () => {
    const progress = fillMotion?.animation.effect?.getComputedTiming().progress;
    return progress == null ? lastFraction : fillMotion.from + (fillMotion.to - fillMotion.from) * progress;
  };
  const stopMotion = () => {
    fillMotion?.animation.cancel();
    fillMotion = null;
    detailMotions.forEach(animation => animation.cancel());
    detailMotions = [];
  };
  const animateDetails = (bar, from, to, duration) => {
    for (const threshold of [2, 4, 6]) {
      const wasReached = from * 6 >= threshold - .001;
      const isReached = to * 6 >= threshold;
      if (wasReached === isReached) continue;
      const svg = bar.querySelector('.ff-cart-volume__dot--' + threshold + ' svg');
      const label = bar.querySelectorAll('.ff-cart-volume__milestones li')[threshold / 2 - 1];
      const distance = Math.abs(to - from);
      const crossing = distance ? Math.min(1, Math.abs(threshold / 6 - from) / distance) : 0;
      const delay = duration * crossing * .3;
      if (svg) detailMotions.push(svg.animate([
        { fill: wasReached ? '#bd326f' : '#fff5f9', stroke: wasReached ? '#fff5f9' : '#c79caf' },
        { fill: isReached ? '#bd326f' : '#fff5f9', stroke: isReached ? '#fff5f9' : '#c79caf' }
      ], { duration: 220, delay, fill: 'backwards', easing: 'ease-out' }));
      if (label) detailMotions.push(label.animate([
        { color: wasReached ? '#a32960' : '#735c67' },
        { color: isReached ? '#a32960' : '#735c67' }
      ], { duration: 220, delay, fill: 'backwards' }));
    }
    const message = bar.querySelector('.ff-cart-volume__message');
    if (message) detailMotions.push(message.animate([
      { opacity: .45, transform: 'translateY(2px)' },
      { opacity: 1, transform: 'translateY(0)' }
    ], { duration: 260, easing: 'ease-out' }));
  };

  const celebrate = (bar, tier) => {
    if (!bar.isConnected || reducedMotion.matches) return;
    const drawer = bar.closest('dialog');
    if (!drawer?.open) return;
    const dot = bar.querySelector('.ff-cart-volume__dot--' + tier);
    const label = bar.querySelectorAll('.ff-cart-volume__milestones li')[tier / 2 - 1];
    const duration = tier === 6 ? 900 : 700;
    const animations = [];
    const animate = (element, frames, options) => {
      if (element) animations.push(element.animate(frames, options));
    };
    bar.classList.add('is-celebrating');
    bar.dataset.celebratingTier = String(tier);
    animate(dot, [
      { transform: 'translateX(-50%) scale(1)' },
      { transform: 'translateX(-50%) scale(1.35)', offset: .3 },
      { transform: 'translateX(-50%) scale(1)' }
    ], { duration: 450, easing: 'ease-out' });
    if (tier === 6 && dot) {
      animations.pop().cancel();
      animate(dot, [
        { transform: 'scale(1)' },
        { transform: 'scale(1.4)', offset: .3 },
        { transform: 'scale(1)' }
      ], { duration: 500, easing: 'ease-out' });
    }
    animate(label, [
      { transform: 'translateY(0) scale(1)' },
      { transform: 'translateY(-2px) scale(1.04)', offset: .35 },
      { transform: 'translateY(0) scale(1)' }
    ], { duration: 650, easing: 'ease-out' });
    const layer = document.createElement('div');
    layer.className = 'ff-cart-volume__celebration';
    layer.setAttribute('aria-hidden', 'true');
    const glow = document.createElement('span');
    glow.className = 'ff-cart-volume__glow';
    layer.append(glow);
    bar.append(layer);
    animate(glow, [{ opacity: 0 }, { opacity: .75, offset: .2 }, { opacity: 0 }], { duration });
    const colors = ['#bd326f', '#de88ad', '#e8b54b', '#f3bfd7'];
    const pieces = tier === 6 ? 12 : 8;
    for (let index = 0; index < pieces; index++) {
      const piece = document.createElement('span');
      piece.className = 'ff-cart-volume__confetti';
      piece.style.left = '50%';
      piece.style.top = '58%';
      piece.style.backgroundColor = colors[index % colors.length];
      const direction = index % 2 ? 1 : -1;
      const distance = direction * (20 + Math.random() * 115);
      const lift = 14 + Math.random() * 42;
      const rotation = direction * (90 + Math.random() * 180);
      layer.append(piece);
      animate(piece, [
        { transform: 'translate(0, 0) rotate(0deg) scale(.6)', opacity: 0 },
        { transform: 'translate(' + distance * .5 + 'px, -' + lift + 'px) rotate(' + rotation * .5 + 'deg) scale(1)', opacity: 1, offset: .35 },
        { transform: 'translate(' + distance + 'px, 28px) rotate(' + rotation + 'deg) scale(.7)', opacity: 0 }
      ], { duration: duration + index * 10, easing: 'cubic-bezier(.2,.65,.45,1)' });
    }
    const finish = () => {
      layer.remove();
      bar.classList.remove('is-celebrating');
      delete bar.dataset.celebratingTier;
    };
    Promise.allSettled(animations.map(animation => animation.finished)).then(finish);
    const stop = () => {
      if (reducedMotion.matches) animations.forEach(animation => animation.cancel());
    };
    reducedMotion.addEventListener('change', stop);
    Promise.allSettled(animations.map(animation => animation.finished)).then(() => {
      reducedMotion.removeEventListener('change', stop);
    });
  };

  document.addEventListener('cart:drawer:render', () => {
    const bar = getBar();
    const currentRevision = ++revision;
    const from = getVisualFraction();
    stopMotion();
    if (!bar) {
      lastQuantity = null;
      lastFraction = 0;
      return;
    }
    const quantity = Number(bar.dataset.quantity);
    const to = Math.min(Math.max(quantity, 0), 6) / 6;
    const tier = getTier(quantity);
    const upgraded = lastQuantity !== null && tier > getTier(lastQuantity);
    const changed = lastQuantity !== null && quantity !== lastQuantity;
    lastQuantity = quantity;
    lastFraction = to;
    const fill = bar.querySelector('.ff-cart-volume__fill');
    if (!fill || !changed || reducedMotion.matches || !bar.closest('dialog')?.open) return;
    const duration = Math.abs(to - from) > .01 ? 620 : 0;
    if (duration) {
      const animation = fill.animate([
        { transform: 'scaleX(' + from + ')' },
        { transform: 'scaleX(' + to + ')' }
      ], { duration, easing: 'cubic-bezier(.22,1,.36,1)' });
      fillMotion = { animation, from, to };
      animateDetails(bar, from, to, duration);
      animation.finished.then(() => {
        if (currentRevision !== revision) return;
        fillMotion = null;
        if (upgraded) celebrate(bar, tier);
      }).catch(() => {});
    }
  });
  reducedMotion.addEventListener('change', () => {
    if (!reducedMotion.matches) return;
    revision++;
    stopMotion();
  });
})();
